module.exports = __webpack_public_path__ + "media/images/application/template/icon-select-white-5a455118b5940beed3caa88aff9d567d.svg";